export default {
  "content": "<g clip-path=\"url(#clip0_880_2660)\"><path d=\"M6 6.55l5.47-4.256a.744.744 0 00-.22-.044H.75a.744.744 0 00-.22.044L6 6.55z\" fill=\"#4E4EDA\"/><path d=\"M6.46 8.092a.75.75 0 01-.92 0L0 3.784V9a.75.75 0 00.75.75h10.5A.75.75 0 0012 9V3.784L6.46 8.092z\" fill=\"currentColor\"/></g><defs><clipPath id=\"clip0_880_2660\"><path fill=\"#fff\" d=\"M0 0h12v12H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "13",
    "viewBox": "0 0 16 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};